import script from "./PCHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PCHeader.vue?vue&type=script&setup=true&lang=ts"

import "./PCHeader.vue?vue&type=style&index=0&id=5247f61f&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5247f61f"]])

export default __exports__